import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getChatApiClient } from "@shared/apis/sidekick/api-factories";

type UseDeleteThreadProps = {
  onSuccess?: () => void;
};

export const useDeleteThread = (props?: UseDeleteThreadProps) => {
  const { onSuccess } = props || {};
  const chatApi = getChatApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: { threadId: string }) => {
      const response = await chatApi.chatControllerDeleteThread({
        thread: params.threadId,
      });
      queryClient.invalidateQueries({ queryKey: ["threads"] });
      queryClient.invalidateQueries({ queryKey: ["last-thread"] });
      onSuccess?.();
      return response;
    },
    onSuccess: async () => {},
    onError: (error, { threadId }) => {
      console.error(`Failed to delete thread ${threadId}`, error);
    },
  });

  return mutation;
};
